import $axios from "@/common/http"  //导入封装的axios

// 获取省份
export function queryProvince(data:any){
    return $axios.get("/province/selectList",{params:data})
}
// 获取城市
export function queryCity(data:any){
    return $axios.get("/city/selectList",{params:data})
}
// 获取上传附件code
export function getAttachmentCode(data:any){
  return $axios.post("/attachment/getAttachmentCode",{params:data})
}
// 保存考试信息
export function saveExam(data:any){
  const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): ""
  return $axios.post("/sysappointmentexammain/save",data,{headers:{'Content-Type': 'application/json',token:token}})
}
// 获取考试日历列表
export function rlSelectList(data:any){
    return $axios.get("/sysexamtimemanager/selectList",{params:data})
}


// 下载上传模板
export function downloadAction(
    data: any,
  ) {
    return $axios.get('/sysappointmentexammain/downloadTemplate',{
      params:data,
      headers:{"Content-Type": "application/json;" },
      timeout:0,
      responseType:'blob',
    });
  }
  
  // upload 文件上传
export function uploadAction(
  url: any,
  data: any,
  timeout = 0,
  headers = {
    "Content-Type":"multipart/form-data;"
  }
) {
  return $axios.post(url,
    data,
    {
    headers,
    timeout
  }
  );
}
// 删除学员细心  逻辑删除
export function deleteUserByStatusExam(data:any){
  const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): ""
  return $axios.post("/sysappointmentexamchild/deleteByStatus",data,{headers:{'Content-Type': 'application/json',token}})
}
// 学员列表  分页
export function userListExam(data:any){
  const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): ""
  return $axios.get("/sysappointmentexamchild/list",{params:data,headers:{'Content-Type': 'application/json',token}})
}


// 查看报考信息
export function examInfo(data:any){
  const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): ""
  return $axios.get("/sysappointmentexammain/info",{params:data,headers:{'Content-Type': 'application/json',token}})
}

// 修改报考信息
export function updateExam(data:any){
  const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): ""
  return $axios.post("/sysappointmentexammain/update",data,{headers:{'Content-Type': 'application/json',token}})
}
